import { FeedbackResponseInterface } from '@types';

export type FeedbackState = {
  supportData: FeedbackResponseInterface;
  isLoading: boolean;
};

export const feedbackInitialState: FeedbackState = {
  supportData: { users: [], emails: [] },
  isLoading: false,
};
